import React from 'react';

interface NoDataOverlayProps {
    visible: boolean;
    title?: string;
    subtitle?: string;
    icon?: string;
}

const NoDataOverlay: React.FC<NoDataOverlayProps> = ({
    visible,
    title = "No Data Available",
    subtitle = "Please select a hospital or check back later",
    icon = "🚫"
}) => {
    if (!visible) return null;

    return (
        <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            backdropFilter: 'blur(12px)',
            WebkitBackdropFilter: 'blur(12px)',
            zIndex: 999,
            color: '#333',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            textAlign: 'center',
            padding: '2rem',
            minHeight: '400px'
        }}>
            <div style={{ fontSize: '4rem', color: '#cc0000', marginBottom: '1rem' }}>{icon}</div>
            <div style={{ fontSize: '1.125rem', fontWeight: 'bold', color: '#333', fontFamily: 'Segoe UI, sans-serif', marginBottom: subtitle ? '0.5rem' : '0' }}>{title}</div>
            {subtitle && <div style={{ fontSize: '0.875rem', color: '#666', fontFamily: 'Segoe UI, sans-serif' }}>{subtitle}</div>}
        </div>
    );
};

export default NoDataOverlay;
